import { ACTIVE_CALLER_SESSION, ACTIVE_CALLER_SESSION_SUCCESS, ACTIVE_CALLER_SESSION_ERROR, ACTIVE_CALLER_SESSION_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ActiveCallerSession = (state = initialState, action) => {
  switch (action.type) {
    case ACTIVE_CALLER_SESSION:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case ACTIVE_CALLER_SESSION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case ACTIVE_CALLER_SESSION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case ACTIVE_CALLER_SESSION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ActiveCallerSession;
